"use strict";
// (C) 2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterLabel = void 0;
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./typings"), exports);
var FilterLabel_1 = require("./FilterLabel");
Object.defineProperty(exports, "FilterLabel", { enumerable: true, get: function () { return FilterLabel_1.FilterLabel; } });
//# sourceMappingURL=index.js.map